export default {
  pageHeroV1: {
    container: {
      height: '75vh',
      width: '100%',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      alignItems: 'center',
      justifyContent: 'center'
    },

    content: {
      flexDirection: 'column',
      color: 'white',
      textAlign: 'center',
      h1: {
        fontSize: ['2.5rem', '', '4.5rem'],
        marginBottom: 1,
        letterSpacing: '3px',
        borderColor: 'secondary',
        // backgroundColor: 'rgba(0,0,0,0.35)',
        padding: '1rem',
        fontFamily: 'heading',
        textShadow: '6px 6px 0px #f9ad19',
        fontWeight: 'bolder',
        color: 'light',
        textTransform: 'uppercase'
      },
      h2: {
        marginBottom: 4
      }
    }
  }
}
